import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { StudentsService } from '../../../../api/Services/maintenance/students.service';
import { ToastrService } from 'ngx-toastr';
import { TabService } from '../../../../tabconfig/tab.service';
import { MatDialog } from '@angular/material/dialog';
import { StudentsListComponent } from '../students-list/students-list.component';
import { Tab } from '../../../../tabconfig/tab.model';
import { AuthService } from '../../../../system/auth.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { DialogService } from '../../../../common/dialog.service';
import { PersonService } from '../../../../api/Services/maintenance/person.service';
import { CommonService } from '../../../../api/Services/common/common.service';

@Component({
  selector: 'app-students-add',
  templateUrl: './students-add.component.html',
  styleUrls: ['./students-add.component.css']
})
export class StudentsAddComponent implements OnInit {
  keywordNacionality = 'sys_vc_description';

  data_nationality: any[];

  @Input() data;
  public editActivo = false;
  public form: FormGroup;
  parameters: any[];
  department: any[];
  province: any[];
  province_filter: any[];
  district: any[];
  district_filter: any[];
  public message_loading: string;


  public select_nationality: string;
  public select_type_document: string;
  public select_rol_in_type: string;
  public select_per_in_gender: string;
  public select_stu_in_institution: string;

  public select_per_in_departament: string;
  public select_per_in_province: string;
  public select_per_in_district: string;

  constructor(
    private formBuilder: FormBuilder,
    private studentsServices: StudentsService,
    private personServices: PersonService,
    private commonServices: CommonService,
    private toastr: ToastrService,
    private tabService: TabService,
    private dialog: MatDialog,
    private authService: AuthService,
    private dialogService: DialogService
  ) {




  }

  ngOnInit(): void {

    this.loadInitial();
    this.initForm();
    this.select_nationality = '';
    this.select_type_document = '';
    this.select_rol_in_type = '1';
    this.select_per_in_gender = '';
    this.select_stu_in_institution = '';
    this.select_per_in_departament = '';
    this.select_per_in_province = '';
    this.select_per_in_district = '';

    this.InputDisabled(true);
    if (this.data.tabData.element) {
      console.log(this.data.tabData.element);
      this.form.setValue(this.data.tabData.element);
      this.editActivo = true;
      this.select_nationality = this.form.controls['per_in_nationality'].value;
      this.select_type_document = this.form.controls['per_in_document_type'].value;
      this.select_per_in_gender = this.form.controls['per_in_gender'].value;
      this.select_stu_in_institution = this.form.controls['stu_in_institution'].value;

      this.select_per_in_departament = this.form.controls['per_in_departament'].value;
      this.select_per_in_province = this.form.controls['per_in_province'].value;
      this.select_per_in_district = this.form.controls['per_in_district'].value;

      this.InputDisabled(false);
      this.InputDisabledGet(true);
    }


  }

  public loadInitial() {
    this.parameters = this.authService.getParameters();
    this.data_nationality = this.parameters.filter(x => x.sys_in_group == 300);

    this.commonServices.DepartmentGetAll().subscribe(
      data => {
        if (data['sucess']) {
          this.department = data['data'];
        }
        else {
          this.toastr.warning(data['msg'], 'Advertencia');
        }
      }
    );

    this.commonServices.ProvinceGetAll(0).subscribe(
      data => {
        if (data['sucess']) {
          this.province = data['data'];

          if(this.editActivo){
            this.onChangeDepartment(+this.data.tabData.element['per_in_departament']);
            this.select_per_in_province = this.data.tabData.element['per_in_province'];
          }

        }
        else {
          this.toastr.warning(data['msg'], 'Advertencia');
        }
      }
    );

    this.commonServices.DistricttGetAll(0).subscribe(
      data => {
        if (data['sucess']) {
          this.district = data['data'];

          if(this.editActivo){
            this.onChangeProvince(+this.data.tabData.element['per_in_province']);
            this.select_per_in_district = this.data.tabData.element['per_in_district'];
          }
        }
        else {
          this.toastr.warning(data['msg'], 'Advertencia');
        }
      }
    );
  }

  public initForm() {
    this.form = this.formBuilder.group({
      stu_bi_id: [null],
      stu_in_institution: [null, Validators.required],
      per_bi_id: [null],
      per_in_nationality: [null],
      per_in_document_type: [null, Validators.required],
      per_vc_document_type: [null],
      per_vc_document_number: [null, Validators.required],
      per_vc_first_name: [null, Validators.required],
      per_vc_last_name: [null, Validators.required],
      per_vc_full_names: [null],
      per_in_gender: [null, Validators.required],

      per_vc_email: [null, Validators.required],
      per_vc_phone: [null],
      per_vc_cellphone: [null, Validators.required],

      per_in_departament:[null],
      per_in_province:[null],
      per_in_district:[null],

      per_vc_ubigeo: [null],
      per_vc_photo: [null],
      per_vc_address: [null],
      per_da_birthday:[null],
      stu_in_status: [1],
      stu_vc_status: [null],
      use_bi_id: [null],
      rol_in_type: [null, Validators.required],
      usu_vc_login: [null, Validators.required],
      usu_tx_password: [null, Validators.required]
    });
  }


  CleanControl() {
    this.form.controls['stu_bi_id'].setValue("0");
    this.form.controls['per_bi_id'].setValue("0");
    this.form.controls['per_in_nationality'].setValue("");
    this.form.controls['per_in_document_type'].setValue("");
    this.form.controls['per_vc_document_number'].setValue(null);
    this.form.controls['per_vc_first_name'].setValue(null);
    this.form.controls['per_vc_last_name'].setValue(null);
    this.form.controls['per_vc_email'].setValue(null);
    this.form.controls['per_vc_cellphone'].setValue(null);
    this.form.controls['per_in_gender'].setValue("");
    this.form.controls['per_vc_email'].setValue(null);
  }
  FormClean(){
    this.CleanControl();
    this.InputDisabledGet(false);
    this.InputDisabled(true)
  }
  public register() {

    if (this.form.valid) {

      if (this.form.controls['stu_bi_id'].value != null) { // si es edición hacer put

        this.dialogService.openConfirmDialog('¿Seguro de modificar este registro?')
          .afterClosed().subscribe(res => {

            if (res) {

              this.studentsServices.Update(this.form.getRawValue()).subscribe(
                data => {
                  if (data['sucess']) {
                    this.CleanControl();
                    this.toastr.success(data['msg'], 'Correcto');
                    this.afterSave();
                  }
                  else {

                    this.toastr.warning(data['msg'], 'Advertencia');
                    //if(Msg.sqlMessage != null)

                    //else
                    //this.toastr.warning(Msg, 'Advertencia');
                  }
                }
              );
            }
          });

      } else { // si es nuevo registro hacer post
        this.dialogService.openConfirmDialog('¿Seguro de guardar este registro?')
          .afterClosed().subscribe(res => {

            if (res) {

              this.studentsServices.Insert(this.form.getRawValue()).subscribe(
                data => {
                  console.log(data);

                  if (data['sucess']) {
                    this.CleanControl();
                    this.toastr.success(data['msg'], 'Correcto');
                    this.afterSave();
                  }
                  else {
                    this.toastr.warning(data['msg'], 'Advertencia');
                  }
                }
              );
            }
          });
      }
    } else {
      this.toastr.warning('Por favor complete los datos del formulario.', 'Advertencia');
    }
  }

  public getpersona() {

    let nationality = this.select_nationality;
    let type_document = this.select_type_document;
    let document_number = this.form.controls['per_vc_document_number'].value; //this.form['per_vc_document_number']
    if (nationality == null) {
      this.toastr.warning('seleccione una nacionalidad por favor.', 'Advertencia');
      return;
    }
    if (nationality == '') {
      this.toastr.warning('seleccione una nacionalidad por favor.', 'Advertencia');
      return;
    }

    if (type_document == null) {
      this.toastr.warning('seleccione un tipo de documento por favor.', 'Advertencia');
      return;
    }
    if (type_document == '') {
      this.toastr.warning('seleccione un tipo de documento por favor.', 'Advertencia');
      return;
    }

    if (document_number == null) {
      this.toastr.warning('ingrese el numero documento por favor.', 'Advertencia');
      return;
    }
    if (document_number == '') {
      this.toastr.warning('ingrese el numero documento por favor.', 'Advertencia');
      return;
    }

    this.dialogService.openConfirmDialog('¿Seguro de buscar a la persona con el numero documento : ' + document_number + '?')
      .afterClosed().subscribe(res => {

        if (res) {

          this.personServices.GetAll(1, +type_document, document_number).subscribe(
            data => {
              console.log(data);

              if (data['sucess']) {
                let result = data['data'];
                if (result != null) {
                  if (result.length > 0) {
                    this.InputDisabled(false);
                    this.InputDisabledGet(true);
                    this.form.setValue(result[0]);
                  }
                  else {

                    this.InputDisabled(false);
                    this.InputDisabledGet(false);
                    this.form.controls['per_bi_id'].setValue(null);
                    this.form.controls['per_vc_first_name'].setValue(null);
                    this.form.controls['per_vc_last_name'].setValue(null);
                    this.form.controls['per_vc_email'].setValue(null);
                    this.form.controls['per_vc_cellphone'].setValue(null);
                    this.toastr.warning('No se ha encontrado ningun registro', 'Advertencia');
                  }
                }
                else {
                  this.InputDisabled(false);
                  this.InputDisabledGet(false);
                  this.form.controls['per_bi_id'].setValue(null);
                  this.form.controls['per_vc_first_name'].setValue(null);
                  this.form.controls['per_vc_last_name'].setValue(null);
                  this.form.controls['per_vc_email'].setValue(null);
                  this.form.controls['per_vc_cellphone'].setValue(null);
                  this.toastr.warning('No se ha encontrado ningun registro', 'Advertencia');
                }

              }
              else {
                this.InputDisabled(false);
                this.InputDisabledGet(false);
                this.form.controls['per_bi_id'].setValue(null);
                this.form.controls['per_vc_first_name'].setValue(null);
                this.form.controls['per_vc_last_name'].setValue(null);
                this.form.controls['per_vc_email'].setValue(null);
                this.form.controls['per_vc_cellphone'].setValue(null);
                this.toastr.warning(data['msg'], 'Advertencia');
              }
            }
          );
        }
      });

  }


  InputDisabledGet(value: Boolean) {

    //this._isDisabled = value;
    if (value) {
      this.form.controls['per_in_nationality'].disable();
      this.form.controls['per_in_document_type'].disable();
      this.form.controls['per_vc_document_number'].disable();


    } else {
      this.form.controls['per_in_nationality'].enable();
      this.form.controls['per_in_document_type'].enable();
      this.form.controls['per_vc_document_number'].enable();



    }


  }

  InputDisabled(value: Boolean) {

    //this._isDisabled = value;
    if (value) {
      this.form.controls['per_vc_first_name'].disable();
      this.form.controls['per_vc_last_name'].disable();
      this.form.controls['per_in_gender'].disable();
      this.form.controls['stu_in_institution'].disable();
      this.form.controls['per_vc_cellphone'].disable();
      this.form.controls['per_vc_email'].disable();
      this.form.controls['per_vc_address'].disable();
      this.form.controls['per_in_departament'].disable();
      this.form.controls['per_in_province'].disable();
      this.form.controls['per_in_district'].disable();
      this.form.controls['rol_in_type'].disable();
      this.form.controls['usu_vc_login'].disable();
      this.form.controls['usu_tx_password'].disable();

    } else {


      this.form.controls['per_vc_first_name'].enable();
      this.form.controls['per_vc_last_name'].enable();
      this.form.controls['per_in_gender'].enable();
      this.form.controls['stu_in_institution'].enable();
      this.form.controls['per_vc_cellphone'].enable();
      this.form.controls['per_vc_email'].enable();
      this.form.controls['per_vc_address'].enable();
      this.form.controls['per_in_departament'].enable();
      this.form.controls['per_in_province'].enable();
      this.form.controls['per_in_district'].enable();
      this.form.controls['rol_in_type'].enable();
      this.form.controls['usu_vc_login'].enable();
      this.form.controls['usu_tx_password'].enable();


    }
    /*

           this.form.controls['stu_bi_id'].setValue("0");
          this.form.controls['per_bi_id'].setValue("0");
          this.form.controls['per_in_nationality'].setValue("");
          this.form.controls['per_in_document_type'].setValue("");
          this.form.controls['per_vc_document_number'].setValue(null);
          this.form.controls['per_vc_first_name'].setValue(null);
          this.form.controls['per_vc_last_name'].setValue(null);
          this.form.controls['per_vc_email'].setValue(null);
          this.form.controls['per_vc_cellphone'].setValue(null);
          this.form.controls['per_in_gender'].setValue("");
          this.form.controls['per_vc_email'].setValue(null);
          */

  }
  /*
    public change_nationality(value){
      this.select_nationality =value;
    }
    public change_type_document(value){
      this.select_type_document =value;
    }*/

  public afterSave() {
    this.tabService.removeTab(this.data.id - 1);
   // if (this.data.tabData.parent == 'ListadoComponent') {
      //this.tabService.addTab(new Tab(StudentsListComponent, "Listado de Estudiantes", { parent: 'AppComponent' }));
    //}
  }




  onChangeDepartment(value:number){
    if(this.province!=null){
      this.province_filter = this.province.filter(x => x.dep_in_id == value);
      this.district_filter = null;
      this.select_per_in_district ="";

      if(this.province_filter!=null ){
        this.select_per_in_province ="";
      }
    }



  }
  onChangeProvince(value:number){
   if(this.district!=null){
     debugger;
    this.district_filter = this.district.filter(x => x.prv_in_id == value);

    if(this.district_filter!=null ){
      this.select_per_in_district ="";
    }
   }

  }


}
